import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Form as AntForm, Modal, message } from "antd";
import { valueTypeAdapter } from "../../utils/models";
import { request } from "../../utils/http";
import custom from "../../config/custom";
import Title from "../Title";
import AutoForm from "../AutoForm";
import AutoInput from "../AutoInput";
import { FormattedMessage } from "react-intl";
import * as forms from "../../forms";
import moment from "moment";
import _ from "lodash";

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false,
      visible: "visible" in props ? props.visible : true,
      confirmLoading: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
    }
  }

  getFormUrl() {
    let url = `${custom.baseUrl}/${this.props.model}`;

    if (this.props.hasOwnProperty("id")) {
      url += `/${this.props.id}`;
    }

    return url;
  }

  getFormMethod() {
    if (this.props.hasOwnProperty("id")) {
      return "PATCH";
    } else {
      return "POST";
    }
  }

  sendWhatsapp({ data }) {
    data = data[0];

    const text = `Se ha registrado el tránsito [TMS-${data.id
      .toString()
      .padStart(5, "0")}] en el sistema G-TMS `;

    const phones = ["6644843295", "6643768973", "2226518191"];

    phones.forEach(phone => {
      setTimeout(function() {
        window.open(`whatsapp://send?phone=52${phone}&text=${text}`);
      }, 500);
    });
  }

  handleSubmit() {
    this.setState({ confirmLoading: true });

    this.props.form.validateFieldsAndScroll(async (err, values) => {
      let messageText = null;

      if (
        this.props.model === "reference" &&
        this.props.hasOwnProperty("belongsTo") &&
        (!err || !err.reference)
      ) {
        try {
          const dispatchResponse = await request(
            `${custom.baseUrl}/dispatch/${this.props.belongsTo.id}`
          );

          if (dispatchResponse) {
            const societyId = dispatchResponse.data.billType.societyId;
            const sapNumber = dispatchResponse.data.customer.sapId;
            const year = moment().format('YYYY')[3];
            const month = moment().format("MM");
            const consecutive = "001";
            const internalOrderResponse = {
              data: {
                success: true,
                data: {
                  num_oi: `${societyId}${sapNumber}${year}${month}${consecutive}`,
                  oi_id: 3638474,
                  sap: 1,
                  wasRecentlyCreated: false
                },
                message: `Referencia agregada a orden interna ${societyId}${sapNumber}${year}${month}${consecutive}`
              }
            };

            if (
              internalOrderResponse.data &&
              internalOrderResponse.data.success
            ) {
              const internalOrder = internalOrderResponse.data.data.oi_id;

              await request(
                `${custom.baseUrl}/dispatch/${this.props.belongsTo.id}`,
                {
                  method: "PATCH",
                  data: {
                    internalOrder
                  }
                }
              );

              messageText = internalOrderResponse.data.message;
            } else {
              err = true;
            }
          } else {
            err = true;
          }
        } catch (error) {
          if (error.data && error.data.success) {
            const internalOrder = error.data.data.oi_id;

            await request(
              `${custom.baseUrl}/dispatch/${this.props.belongsTo.id}`,
              {
                method: "PATCH",
                data: {
                  internalOrder
                }
              }
            );

            messageText = error.data.message;
          } else {
            err = true;
          }
        }
      }

      if (!err) {
        request(this.getFormUrl(), {
          method: this.getFormMethod(),
          data: valueTypeAdapter(values)
        })
          .then(response => {
            if (this.props.model === "dispatch") {
              const self = this;

              Modal.confirm({
                title: "Notificar por whatsapp",
                content: (
                  <div>
                    <p>
                      Desea notificar por whatsapp la creación del tránsito?
                    </p>
                  </div>
                ),
                okText: "Si",
                cancelText: "No",
                onOk() {
                  self.sendWhatsapp(response.data);
                },
                onCancel() {}
              });
              messageText = response.message;
            }
            if (response.data) {
              if (this.props.model === "item") this.props.init();
              message.success(response.data.message);
            }

            if (messageText) {
              message.success(messageText);
            }

            this.hide();
          })
          .catch(e => {
            const message = _.get(
              e,
              "response.data.message",
              e.message || "Hubo un problema al guardar"
            );
            message.error(message);
          })
          .then(() => {
            this.setState({ confirmLoading: false });
          });
      } else {
        if (this.props.model === "reference") {
          message.warning("Hubo un problema al guardar");
        }
        this.setState({ confirmLoading: false });
      }
    });
  }

  handleConfirmBlur = e => {
    const value = e.target.value;

    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  clearForm() {
    this.props.form.resetFields();
  }

  getTitle() {
    if (this.props.title) {
      return this.props.title;
    }

    if (this.props.hasOwnProperty("id")) {
      return <Title model={this.props.model} value={this.props.id} />;
    }

    return <FormattedMessage id={`Model.${this.props.model}.add`} />;
  }

  hide() {
    this.setState({ visible: false }, () => {
      this.props.hide();
    });
  }

  getInputs() {
    let formName = this.props.model;
    let CustomForm = forms[formName];

    if (!CustomForm) {
      formName += this.props.id ? "Edit" : "Create";
    }

    CustomForm = forms[formName];

    if (CustomForm) {
      return <CustomForm {...this.props} />;
    }

    return <AutoForm {...this.props} />;
  }

  render() {
    return (
      <div>
        {this.props.model === "quote" && (
          <Modal
            title={this.getTitle()}
            cancelText={<FormattedMessage id={"Form.cancel"} />}
            okText={<FormattedMessage id={"Form.save"} />}
            visible={this.state.visible}
            width={"90vw"}
            onOk={() => {
              this.handleSubmit();
            }}
            confirmLoading={this.state.confirmLoading}
            onCancel={() => {
              this.hide();
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}
            >
              <AntForm onSubmit={this.handleSubmit} style={{ width: "90vw" }}>
                <AutoInput
                  form={this.props.form}
                  model={this.props.model}
                  attribute={"createdBy"}
                  type="number"
                  value={this.props.user.id}
                  hidden
                />
                {this.getInputs()}
              </AntForm>
            </div>
          </Modal>
        )}
        {this.props.model !== "quote" && (
          <Modal
            title={this.getTitle()}
            cancelText={<FormattedMessage id={"Form.cancel"} />}
            okText={<FormattedMessage id={"Form.save"} />}
            visible={this.state.visible}
            width={800}
            onOk={() => {
              this.handleSubmit();
            }}
            confirmLoading={this.state.confirmLoading}
            onCancel={() => {
              this.hide();
              this.props.form.resetFields();
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}
            >
              <AntForm onSubmit={this.handleSubmit} style={{ width: "700px" }}>
                <AutoInput
                  form={this.props.form}
                  model={this.props.model}
                  attribute={"createdBy"}
                  type="number"
                  value={this.props.user.id}
                  hidden
                />
                {this.getInputs()}
              </AntForm>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

Form.propTypes = {
  model: PropTypes.string.isRequired,
  id: PropTypes.number,
  belongsTo: PropTypes.object,
  inputProps: PropTypes.object
};

const mapStateToProps = state => ({
  user: state.auth.user
});

export default connect(mapStateToProps)(AntForm.create()(Form));



// WEBPACK FOOTER //
// ./src/containers/Form/index.js